export default __webpack_public_path__ + "static/media/double-arrow-right.7f6a7458.svg";